import React from 'react';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { Badge } from '@/components/ui/badge';
import { ALL_COURSE_CATEGORIES } from '@/config/courseNavigation';
import { getAllUnifiedCourses } from '@/services/unifiedCourseService';
import { getAllUniversalCourses } from '@/utils/universalCourseResolver';

const CourseIntegrationStatus = () => {
  const allCourses = getAllUnifiedCourses();
  const universalCourses = getAllUniversalCourses();
  const allCategories = ALL_COURSE_CATEGORIES;
  const totalCourses = allCategories.reduce((sum, cat) => sum + cat.courses.length, 0);

  return (
    <Card className="w-full max-w-4xl mx-auto">
      <CardHeader>
        <CardTitle className="text-center">📚 Course Integration Status</CardTitle>
      </CardHeader>
      <CardContent>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
          <div className="col-span-full mb-6 text-center">
            <Badge variant="outline" className="text-lg px-4 py-2">
              Total: {allCategories.length} Categories • {totalCourses} Courses
            </Badge>
          </div>
          
          {allCategories.map((category) => {
            const IconComponent = category.icon;
            return (
              <Card key={category.id} className="border border-muted">
                <CardContent className="p-4">
                  <div className="flex items-center space-x-2 mb-2">
                    <IconComponent className="h-5 w-5 text-primary" />
                    <h3 className="font-semibold text-sm">{category.title}</h3>
                  </div>
                  <p className="text-xs text-muted-foreground mb-2">{category.description}</p>
                  <Badge variant="secondary" className="text-xs">
                    {category.courses.length} courses
                  </Badge>
                </CardContent>
              </Card>
            );
          })}
        </div>

        <div className="mt-6 p-4 bg-muted/30 rounded-lg">
          <h4 className="font-semibold mb-2">✅ Complete Integration Summary:</h4>
          <ul className="text-sm space-y-1">
            <li>• Navigation bar dropdown: All {allCategories.length} categories visible</li>
            <li>• Discover Your Learning Path page: All categories with filtering</li>
            <li>• Main page learning catalog: Featured categories displayed</li>
            <li>• Unified course service: {allCourses.length} courses integrated</li>
            <li>• Universal course resolver: {universalCourses.length} courses integrated</li>
            <li>• Staff assignment modal: All categories available for assignment</li>
            <li>• Admin assignment manager: All categories available for bulk assignment</li>
            <li>• Enhanced course service: Updated to use unified system</li>
            <li>• Complete course catalog: React, Python, SQL, AI, Java, JavaScript, AWS, .NET, C#, Azure, DevOps, Backend, Security, Mobile, GCP, Data Science, Database, Blockchain, RPA, Graphics, Tableau, PowerBI, ETL, AppSec, Infrastructure, Frontend Advanced, Testing, Web3, Serverless, Game Development, UI/UX, Professional Development, Enterprise Training</li>
          </ul>
        </div>
      </CardContent>
    </Card>
  );
};

export default CourseIntegrationStatus;